export const READ = 'READ'
export const DELIVERED = 'DELIVERED'
